module.exports = __webpack_public_path__ + "media/images/icons/filled/shop-980670bdb8be24e0767304d34b86c4de.svg";